import { useApi } from "../../../../service/ApiContext";
import Loader, { LocalStorage } from "../../../../utils/Utils";
import Logger from "../../../../utils/Logger";
import { useAlert } from "../../../../components/AlertContextComponent";
import strings from "../../../../utils/Strings";
import AssessmentQuestionModuleClient from "../client/AssessmentQuestionModuleClient";
import { AssessmentStatus } from "../response/AssessmentStatusResponse";
import { FetchQuestionsResponse } from "../response/QuestionResponse";
import { ResumeQuestionsResponse } from "../response/ResumeResponse";
import { AssessmentAnswerRequest } from "./../request/AssessmentAnswerRequest";
import { AnswerResponse } from "../response/AnswerResponse";
import { useDispatch } from "react-redux";
import { clearAssessment } from "../../../assessment/data/redux/AssessmentSlice";

const AssessmentQuestionModuleApiService = () => {
  const api = useApi();
  const { showAlert } = useAlert();
  const dispatch = useDispatch();
  const setAuthToken = () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
  };
  const fetchQuestions = async (
    question_no: number,
  ): Promise<FetchQuestionsResponse | null> => {
    setAuthToken();
    // Loader.showLoading();
    try {
      const res = await api.post<FetchQuestionsResponse>(
        `${
          AssessmentQuestionModuleClient.fetch_question
        }${question_no}?assessment_id=${LocalStorage.getLocalData(
          strings.localStorage_keys.assessment_details.assessment_id,
        )}`,
      );

      if (res.data !== null) {
        return res.data;
      } else {
        showAlert({
          show: true,
          title: strings.error_msg.error_title,
          message: strings.error_msg.something_wrg,
          button1Text: "Ok",
          alertType: "error",
          onlyNeedOneButton: true,
          btn1onPressed: () => {},
        });
        return null;
      }
    } catch (error) {
      Logger.info("Error response:", error);
      showAlert({
        show: true,
        title: strings.error_msg.something_wrg,
        message: strings.error_msg.something_wrg,
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
      return null;
    } finally {
      // Loader.dismissLoading();
    }
  };
  const fetchResumedStatePrevQuestions =
    async (): Promise<ResumeQuestionsResponse | null> => {
      setAuthToken();
      // Loader.showLoading();
      try {
        const res = await api.post<ResumeQuestionsResponse>(
          `${
            AssessmentQuestionModuleClient.resume_assessment
          }?assessment_id=${LocalStorage.getLocalData(
            strings.localStorage_keys.assessment_details.assessment_id,
          )}`,
        );

        if (res.data !== null) {
          return res.data;
        } else {
          showAlert({
            show: true,
            title: strings.error_msg.error_title,
            message: strings.error_msg.something_wrg,
            button1Text: "Ok",
            alertType: "error",
            onlyNeedOneButton: true,
            btn1onPressed: () => {},
          });
          return null;
        }
      } catch (error) {
        Logger.info("Error response:", error);
        showAlert({
          show: true,
          title: strings.error_msg.error_title,
          message: strings.error_msg.something_wrg,
          button1Text: "Ok",
          alertType: "error",
          onlyNeedOneButton: true,
          btn1onPressed: () => {},
        });
        return null;
      } finally {
        // Loader.dismissLoading();
      }
    };
  const fetchAssessmentStatus = async ({
    onInProgress,
    onNotStarted,
  }: {
    onInProgress: (assessment: AssessmentStatus) => void;
    onNotStarted: (assessment: AssessmentStatus) => void;
  }) => {
    setAuthToken();
    try {
      const response = await api.get(
        AssessmentQuestionModuleClient.list_assessment,
      );
      const data = response.data as AssessmentStatus; // Type assertion

      Logger.info("Assessment API response:", data);

      const assessment = data;
      if (
        assessment.status === strings.assessment_status.initated ||
        assessment.status === strings.assessment_status.inProgress
      ) {
        onInProgress(assessment);
      } else if (
        data.detail === strings.assessment_status.notStarted ||
        data.status === strings.assessment_status.notStarted
      ) {
        onNotStarted(assessment);

        Logger.info("Assessment not started");
      } else {
        clearAssessmentLocalStorage();
        dispatch(clearAssessment());
        showAlert({
          show: true,
          title: "Error",
          message: data.error,
          alertType: "error",
          onlyNeedOneButton: true,
          button1Text: "Cancel",
          btn1onPressed() {},
        });
        Logger.info("Assessment ended or other status");
      }
    } catch (error) {
      Logger.error("Error fetching assessment status:", error);
    }
  };
  const saveAssessmentAnswer = async ({
    param,
  }: {
    param: AssessmentAnswerRequest;
  }): Promise<AnswerResponse | null> => {
    setAuthToken();
    // Loader.showLoading();
    try {
      const res = await api.post<AnswerResponse>(
        AssessmentQuestionModuleClient.save_answer,
        param,
      );

      if (res.data !== null) {
        return res.data;
      } else {
        showAlert({
          show: true,
          title: strings.error_msg.error_title,
          message: strings.error_msg.something_wrg,
          button1Text: "Ok",
          alertType: "error",
          onlyNeedOneButton: true,
          btn1onPressed: () => {},
        });
        return null;
      }
    } catch (error) {
      Logger.info("Error response:", error);
      showAlert({
        show: true,
        title: strings.error_msg.error_title,
        message: strings.error_msg.something_wrg,
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
      return null;
    } finally {
      // Loader.dismissLoading();
    }
  };
  const submitAssessment = async (): Promise<AnswerResponse | null> => {
    setAuthToken();
    // Loader.showLoading();
    try {
      const res = await api.post<AnswerResponse>(
        `${
          AssessmentQuestionModuleClient.submit_assessment
        }?assessment_id=${LocalStorage.getLocalData(
          strings.localStorage_keys.assessment_details.assessment_id,
        )}`,
      );
      if (res.data !== null) {
        return res.data;
      } else {
        showAlert({
          show: true,
          title: strings.error_msg.error_title,
          message: strings.error_msg.something_wrg,
          button1Text: "Ok",
          alertType: "error",
          onlyNeedOneButton: true,
          btn1onPressed: () => {},
        });
        return null;
      }
    } catch (error) {
      Logger.info("Error response:", error);
      showAlert({
        show: true,
        title: strings.error_msg.error_title,
        message: strings.error_msg.something_wrg,
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
      return null;
    } finally {
      // Loader.dismissLoading();
    }
  };
  const clearAssessmentLocalStorage = () => {
    LocalStorage.removeLocalData(
      strings.localStorage_keys.assessment_details.assessment_id,
    );
    LocalStorage.removeLocalData(
      strings.localStorage_keys.assessment_details.current_counter,
    );
    LocalStorage.removeLocalData(
      strings.localStorage_keys.assessment_details.duration,
    );
    LocalStorage.removeLocalData(
      strings.localStorage_keys.assessment_details.isIndependent,
    );
    LocalStorage.removeLocalData(
      strings.localStorage_keys.assessment_details.candidate_assessment_status,
    );
    LocalStorage.removeLocalData(
      strings.localStorage_keys.assessment_details.time_spend,
    );
    LocalStorage.removeLocalData(
      strings.localStorage_keys.assessment_details.total_question,
    );
  };
  return {
    fetchQuestions,
    fetchResumedStatePrevQuestions,
    fetchAssessmentStatus,
    saveAssessmentAnswer,
    submitAssessment,
    clearAssessmentLocalStorage,
  };
};

export default AssessmentQuestionModuleApiService;
